"use strict";

// COOKIES

// function getCookie(cname) {
// 		var name = cname + "=";
// 		var decodedCookie = decodeURIComponent(document.cookie);
// 		var ca = decodedCookie.split(';');
// 		for(var i = 0; i <ca.length; i++) {
// 				var c = ca[i];
// 				while (c.charAt(0) == ' ') {
// 						c = c.substring(1);
// 				}
// 				if (c.indexOf(name) == 0) {
// 						return c.substring(name.length, c.length);
// 				}
// 		}
// 		return "";
// }

//function delete_cookie(name) { setCookie(name, '', -1); }

function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		var expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function setCookieLaw() {

		closeCookies();

		setCookie('cookie_agreement', "YES", 1000);

		//window['ga-disable-UA-47924443-30'] = false;
		//window['ga-disable-UA-47924443-27'] = false;//Specto

		//window['GoogleAnalyticsObject'] = 'ga';
		//window['ga'] = window['ga'] || function() {
		//  (window['ga'].q = window['ga'].q || []).push(arguments)
		//};

		//ga('create', 'UA-47924443-33', 'auto');
		//ga('send', 'pageview');
		//ga('clientTracker.send', 'pageview');

		//gtag('config', 'UA-47924443-33', {
		//  'page_title' : 'homepage',
		//  'page_path': '/index.php'
		//});

		var ga_id = $('#div-cookie input').val();

		window.dataLayer = window.dataLayer || [];
		function gtag() {
				dataLayer.push(arguments);
		}
		gtag('js', new Date());

		gtag('config', ga_id);
}

function closeCookies() {
		$("#div-cookie").fadeOut('fast', function () {});
		//$("#div-cookie").toggleClass("popup-off", 300);
}

$("#span-cookies-agree").click(function () {
		setCookieLaw();
});

// $("#span-cookies-reject").click(function (){
//   setCookie('cookie_agreement', "NO", 1); 
//   closeCookies();
// });